import React from 'react'
import styles from './ClubEventRow.scss'
import { ClubEventCard } from 'common/hovercards/ClubEventCard'
import moment from 'moment'
import { shortTimeStr } from 'lib/calendarUtils'

export class ClubEventRow extends React.PureComponent {
  static defaultProps = {
    showHoverCard: true
  }

  render () {
    const { event, showHoverCard, accessors, shownOn, color, wrapperProps } = this.props
    const { start } = accessors

    const Wrapper = showHoverCard ? ClubEventCard : (props) => props.children

    // Only show the date in front of the event name, if this event row is displayed on the start day
    const startDate = moment(start(event))
    const timeStr = moment(shownOn).isSame(startDate, 'day') && shortTimeStr(startDate)

    // We're going to add some transparency to the color if its plain hex, so black text looks good and it kind of balances right with the other colors on the page
    const colorValue = color && color.length === 6 ? `#${color}3C` : color

    return (
      <Wrapper event={event} accessors={accessors} {...wrapperProps}>
        <div className={styles.ClubEventRow} style={{ backgroundColor: color && colorValue }}>
          <a href={`/events/${event.slug}`} target='_blank'>
            <span className={styles.name}>{timeStr && timeStr + ' '}{event.name}</span>
          </a>
        </div>
      </Wrapper>
    )
  }
}
